


























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import Filters from './Filters.vue'
import { AccordionFilters } from '@/components'

// services
import { PermissionControlsService } from '@/services/dailyControl'

// Models
import { Paginator } from '@/models'
import { FiltersPermissionControl, PermissionControlModel } from '@/models/dailyControl'

@Component({
    name: 'TableListPermissionControls',
    components: {
        DataTable,
        Filters,
        AccordionFilters
    }
})
export default class TableListPermissionControls extends Vue {
    @Prop({ required: true, type: Object }) filters!: FiltersPermissionControl
    loading = false
    items: PermissionControlModel[] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'employee.name',
            sortable: true,
            label: 'Empleado',
            thClass: 'one-line w-30'
        },
        {
            key: 'reason.description',
            sortable: true,
            thClass: 'one-line w-30',
            label: 'Motivo'
        },
        {
            key: 'date_start',
            sortable: true,
            thClass: 'one-line w-30',
            label: 'Fecha Inicial'
        },
        {
            key: 'date_end',
            sortable: true,
            thClass: 'one-line w-30',
            label: 'Fecha Final'
        },
        {
            key: 'observations',
            sortable: true,
            thClass: 'one-line w-30',
            label: 'Observaciones'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '8%'
            }
        }
    ]

    created () {
        this.getPermissionControlsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getPermissionControlsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getPermissionControlsWithPagination()
    }

    getByFilters () {
        this.pagination.currentPage = 1
        this.getPermissionControlsWithPagination()
    }

    clearFilters () {
        this.pagination.currentPage = 1
        this.filters.dateStart = null
        this.filters.dateEnd = null
        this.filters.employee = null
        this.filters.reason = null
        this.getPermissionControlsWithPagination()
    }

    async getPermissionControlsWithPagination () {
        this.loading = true
        const response = await PermissionControlsService.getWithPagination(
            this.pagination.perPage,
            this.pagination.currentPage,
            this.filters
        )
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
